import React from 'react';
import { putPAAAA010ClickBanner } from '../../services/Api';
import { getImageSrc } from '../../utils';
import RecruitItem from './RecruitItem';
import Loader from './Loader';

const RecruitList = ({ loading, results, recruitBanner, dataConFig, openPopup, page, setRecruitList }) => {
    return (
        <ul className="table wrap-table table-yellow">
            {results && results.length > 0 ? (
                results.map((result, index) => {
                    const ITEMS_PER_BANNER = dataConFig?.bannerConfig.grandCnt || 15;
                    const bannersNeeded = Math.floor(results.length / ITEMS_PER_BANNER);
                    const bannerOffset =
                        recruitBanner && recruitBanner.length > 0
                            ? ((page - 1) * bannersNeeded) % recruitBanner.length
                            : 0;
                    const bannerIndex =
                        recruitBanner && recruitBanner.length > 0
                            ? (bannerOffset + Math.floor(index / ITEMS_PER_BANNER)) % recruitBanner.length
                            : 0;

                    return recruitBanner && recruitBanner.length > 0 ? (
                        <React.Fragment key={index}>
                            {index % ITEMS_PER_BANNER === 0 && recruitBanner[bannerIndex] && (
                                <a
                                    href={recruitBanner[bannerIndex].linkUrl}
                                    className="line-after-tab"
                                    target={recruitBanner[bannerIndex].linkType}
                                    onClick={async () => {
                                        await putPAAAA010ClickBanner(recruitBanner[bannerIndex]?.seq);
                                    }}
                                >
                                    <img
                                        src={getImageSrc(
                                            'banner_photo_recruit',
                                            recruitBanner[bannerIndex].imgNameMain,
                                        )}
                                        alt="Dental Job Banner"
                                    />
                                </a>
                            )}

                            <RecruitItem
                                item={result}
                                saveHistory={true}
                                openPopup={openPopup}
                                showStar={true}
                                roleAction="P"
                                setRecruitList={setRecruitList}
                            />
                        </React.Fragment>
                    ) : (
                        <React.Fragment key={index}>
                            <RecruitItem
                                item={result}
                                saveHistory={true}
                                openPopup={openPopup}
                                showStar={true}
                                roleAction="P"
                                setRecruitList={setRecruitList}
                            />
                        </React.Fragment>
                    );
                })
            ) : (
                <>
                    {loading ? (
                        <p className="center-loadding">
                            <Loader />
                        </p>
                    ) : (
                        <>
                            {recruitBanner && recruitBanner.length > 0 && (
                                <a
                                    href={recruitBanner[0].linkUrl}
                                    className="line-after-tab"
                                    target={recruitBanner[0].linkType}
                                    onClick={async () => {
                                        await putPAAAA010ClickBanner(recruitBanner[0]?.seq);
                                    }}
                                >
                                    <img
                                        src={getImageSrc('banner_photo_recruit', recruitBanner[0].imgNameMain)}
                                        alt="Dental Job Banner"
                                    />
                                </a>
                            )}
                            <li className="no-data justify-content-center pb-4">등록된 채용정보가 없습니다.</li>
                        </>
                    )}
                </>
            )}
        </ul>
    );
};

export default RecruitList;
